export function preventDefaults(e: Event): void {
  e.preventDefault();
  e.stopPropagation();
}

export function preventDragOnElement(el: HTMLElement): void {
  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    el.addEventListener(eventName, preventDefaults, false);
  });
}

export function undoPreventDragOnElement(el: HTMLElement): void {
  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    el.addEventListener(eventName, preventDefaults, false);
  });
}

export async function readEntriesPromise(directoryReader: FileSystemDirectoryReader): Promise<FileSystemEntry[]> {
  try {
    return await new Promise((resolve, reject) => {
      directoryReader.readEntries(resolve, reject);
    });
  } catch (err) {
    console.log(err);
    return [];
  }
}

export async function collectAllDirectoryEntries(
  directoryReader: FileSystemDirectoryReader,
  queue: FileSystemEntry[],
): Promise<void> {
  let readEntries = await readEntriesPromise(directoryReader);
  while (readEntries.length > 0) {
    queue.push(...readEntries);
    readEntries = await readEntriesPromise(directoryReader);
  }
}
